<template>
  <div class="skill-container">
    <!-- Animasyonlu İkon -->
    <div class="skill-icon-wrapper">
      <!-- Web Tasarım - Code -->
      <svg :class="['skill-icon', text === 0 ? 'is-visible' : 'is-hidden']" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
      </svg>
      
      <!-- N8N Otomasyon -->
      <svg :class="['skill-icon', text === 1 ? 'is-visible' : 'is-hidden']" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="5" cy="12" r="2.5"/>
        <circle cx="12" cy="5" r="2.5"/>
        <circle cx="19" cy="12" r="2.5"/>
        <circle cx="12" cy="19" r="2.5"/>
        <path d="M7.5 12h2M14.5 12h2M12 7.5v2M12 14.5v2" stroke="currentColor" stroke-width="1.5" fill="none"/>
      </svg>
      
      <!-- Yapay Zeka - Lightbulb -->
      <svg :class="['skill-icon', text === 2 ? 'is-visible' : 'is-hidden']" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z"/>
      </svg>
      
      <!-- Shopify - Bag -->
      <svg :class="['skill-icon', text === 3 ? 'is-visible' : 'is-hidden']" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm0 10c-2.21 0-4-1.79-4-4h2c0 1.1.9 2 2 2s2-.9 2-2h2c0 2.21-1.79 4-4 4z"/>
      </svg>
      
      <!-- WordPress - W -->
      <svg :class="['skill-icon', text === 4 ? 'is-visible' : 'is-hidden']" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-1.53.43-2.96 1.17-4.18L9.3 20.08A8.01 8.01 0 014 12zm8 8c-.68 0-1.34-.09-1.97-.25l2.09-6.08 2.14 5.87c.01.03.03.05.04.08-.72.24-1.48.38-2.3.38zm.89-11.89c.42-.02.79-.07.79-.07.37-.04.33-.6-.04-.58 0 0-1.12.09-1.85.09-.69 0-1.83-.09-1.83-.09-.37-.02-.42.56-.05.58 0 0 .35.04.72.07l1.07 2.94-1.51 4.53-2.51-7.47c.42-.02.79-.07.79-.07.37-.04.33-.6-.04-.58 0 0-1.12.09-1.85.09-.13 0-.28 0-.44-.01A7.96 7.96 0 0112 4c2.59 0 4.94 1.23 6.42 3.13-.04 0-.08-.01-.12-.01-.69 0-1.18.6-1.18 1.25 0 .58.34 1.07.7 1.65.27.47.58 1.07.58 1.94 0 .6-.23 1.3-.54 2.27l-.71 2.36-2.55-7.6z"/>
      </svg>
      
      <!-- E-Ticaret - Cart -->
      <svg :class="['skill-icon', text === 5 ? 'is-visible' : 'is-hidden']" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
      </svg>
    </div>
    
    <!-- Başlık Metni - Sabit genişlik alanı -->
    <div class="text-wrapper">
      <span class="cd-headline rotate-1">
        <span class="cd-words-wrapper">
          <b
            :class="text == i ? 'is-visible' : 'is-hidden'"
            v-for="(skill, i) in skills"
            :key="i"
          >
            {{ skill }}</b
          >
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: `AnimationText`,
  data() {
    return {
      skills: ["Web Tasarım", "N8N Otomasyon", "Yapay Zeka Çözümleri", "Shopify Uzmanı", "WordPress Geliştirici", "E-Ticaret Entegrasyonu"],
      text: 0,
    };
  },
  mounted() {
    const interval = setInterval(() => {
      this.text = this.text < this.skills.length - 1 ? this.text + 1 : 0;
    }, 3000);
    return () => clearInterval(interval);
  },
};
</script>

<style scoped>
.skill-container {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

/* İkon Wrapper - Sol tarafta sabit */
.skill-icon-wrapper {
  position: relative;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.skill-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 28px;
  height: 28px;
  color: var(--main-color, #00D4BD);
  filter: drop-shadow(0 0 8px var(--main-color, #00D4BD));
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.5s ease-out;
}

.skill-icon.is-visible {
  opacity: 1;
  transform: scale(1);
}

.skill-icon.is-hidden {
  opacity: 0;
  transform: scale(0.5);
}

/* Metin alanı - Sabit genişlik, sola hizalı */
.text-wrapper {
  width: 280px;
  flex-shrink: 0;
  text-align: left;
}

/* Responsive */
@media (max-width: 768px) {
  .skill-icon-wrapper {
    width: 22px;
    height: 22px;
  }
  
  .skill-icon {
    width: 22px;
    height: 22px;
  }
  
  .skill-container {
    gap: 8px;
  }
  
  .text-wrapper {
    width: 200px;
  }
}
</style>
